module.exports = __webpack_public_path__ + "static/media/services-genetic-test-cbd.87929d1d.jpeg";